import { createReducer } from '@reduxjs/toolkit';

import getEbayCategoryList from '../../thunks/general/getEbayCategoryList';

const initialState = {
  loading: false,
  error: null,
  list: [],
};

const getEbayCategoryListReducer = createReducer(initialState, {
  [getEbayCategoryList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getEbayCategoryList.fulfilled]: (state, { payload }) => ({
    ...state,
    list: payload,
    loading: false,
  }),
  [getEbayCategoryList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getEbayCategoryListReducer;
